import { connect } from 'react-redux';
import CorrectionReadyProductsTable from './CorrectionSemiProductsTable';
import { updateReadyProducts } from '../../../store/actions/inputReadyProducts';
import { getReadyProducts } from '../../../store/actions/correctionReadyProducts';

const mapStateToProps = ({
  correctionSemiProductsReducer,
  inputReadyProductReducer
}) => ({
  correctionSemiProductsReducer,
  inputReadyProductReducer
});
const mapDispatchToProps = { updateReadyProducts, getReadyProducts };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CorrectionReadyProductsTable);
